import {
  GET_FLEET_CONTENT,
  ADD_FLEET_CONTENT,
  FLEET_CONTENT_ERROR,
  ON_GET_FLEET_CONTENT,
} from "../../actions/types";

const initialState = {
  fleet: null,
  loading: true,
  error: {},
};

export default function foo(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ON_GET_FLEET_CONTENT:
      return {
        ...state,
        loading: true,
      };
    case GET_FLEET_CONTENT:
      return {
        ...state,
        cmspage: payload,
        loading: false,
      };
    case ADD_FLEET_CONTENT:
      return {
        ...state,
        cmspage: payload,
        loading: false,
      };
    case FLEET_CONTENT_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
